export const styles = {
  preview: {
    float: "left",
  },
  dropzone: {
    width: 300,
    height: 200,
    borderWidth: 1,
    borderColor: "#D6D6D6",
    borderStyle: "dashed",
    cursor: "pointer",
    borderRadius: 5,
  },
  insideBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "inherit",
    fontSize: 12,
  },
  container: {
    display: "inline-block",
    position: "relative",
    padding: 5,
  },
  removeButton: {
    position: "absolute",
    minWidth: "2rem",
    opacity: 1,
  },
  removeButtonHovered: {
    opacity: 1,
  },
  gridImage: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    paddingTop: 10,
    paddingBottom: 10,
  },
  image: {
    maxHeight: "15rem",
    margin: "0.2rem",
    maxWidth: "100%",
  },
  images: {
    maxHeight: "15rem",
    margin: "0.2rem",
    maxWidth: "60%",
  },
  images_all: {
    width: 160,
    height: 160,
    margin: "0.8rem",
  },
}
